import React from 'react';
import clsx from 'clsx';
import styles from './Button.module.scss';

const Button = ({ children, onClick, icon = null, iconPosition = 'right', className, ...props }) => {
  const isIconLeft = iconPosition === 'left';

  return (
    <button className={clsx(styles.btn, className)} onClick={onClick} {...props}>
      {icon && isIconLeft ? <span className={clsx(styles.icon)}>{icon}</span> : null}
      <span>{children}</span>
      {icon && !isIconLeft ? <span className={clsx(styles.icon)}>{icon}</span> : null}
    </button>
  );
};

export default Button;
